/* eslint-disable no-undef */

(function () {
  'use strict'
  const OFFSET_TO_LOAD_MORE = 200
  const THROTTLE_IN_MS = 500

  let lastExecution = new Date(new Date().getTime() - THROTTLE_IN_MS)

  function scrollReachedLimit (elem, attrs) {
    if (attrs.hasOwnProperty('scrollLimitTop')) {
      return elem.scrollTop <= OFFSET_TO_LOAD_MORE
    }
    return elem.scrollTop + elem.offsetHeight + OFFSET_TO_LOAD_MORE >= elem.scrollHeight
  }

  function applyToScopeWithThrottle (scope, elem, attrs) {
    if (lastExecution.getTime() + THROTTLE_IN_MS <= (new Date()).getTime()) {
      lastExecution = new Date()
      return scope.$apply(attrs.onScrollLimit)
        .then(function (hasMoreItens) {
          if (elem.scrollTop === 0 && hasMoreItens) {
            elem.scrollTop = OFFSET_TO_LOAD_MORE
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }

  // eslint-disable-next-line no-undef
  angular.module('MktzapApp.Directives').directive('onScrollLimit', function () {
    return {
      restrict: 'A',
      link: function (scope, elemJquery, attrs) {
        const elem = elemJquery[0]
        elemJquery.bind('scroll', function () {
          if (scrollReachedLimit(elem, attrs)) {
            applyToScopeWithThrottle(scope, elem, attrs)
          }
        })
      }
    }
  })
  // eslint-disable-next-line semi
})();
